import request from '../../utils/request';

// OVO-120 — tour catalog API (per partner)

export function listToursForPartner(partnerId) {
  return request(`/partners/${partnerId}/tours`, { method: 'GET' });
}

export function createTour(partnerId, data) {
  return request(`/partners/${partnerId}/tours`, { method: 'POST', data });
}

export function updateTour(id, data) {
  return request(`/tours/${id}`, { method: 'PATCH', data });
}

export function deleteTour(id) {
  return request(`/tours/${id}`, { method: 'DELETE' });
}

// OVO-120 — mapping rules API (per partner)

export function listMappingRulesForPartner(partnerId) {
  return request(`/partners/${partnerId}/tour-mapping-rules`, { method: 'GET' });
}

export function createMappingRule(partnerId, data) {
  return request(`/partners/${partnerId}/tour-mapping-rules`, {
    method: 'POST',
    data,
  });
}

export function updateMappingRule(id, data) {
  return request(`/tour-mapping-rules/${id}`, { method: 'PATCH', data });
}

export function deleteMappingRule(id) {
  return request(`/tour-mapping-rules/${id}`, { method: 'DELETE' });
}
